module.exports = __webpack_public_path__ + "img/a95aa0de3107aec3497a57330752762e.png";